<template>
  <div class="product">
    <div class="index-image">
      <div class="inner-text">
        <p class="title">Solutions</p>
        <p class="content">Our team strives to provide financial institutions with various solutions, including MAU growth, business growth, cost reduction, and benefits increase, and help them improve the level of intelligence.</p>
      </div>
    </div>
    <div class="index-next-content">
      <div class="inner-content">
        <div class="main-title">Easy access and convenient management</div>
        <div class="next-main-title">One-stop management platform and whole-process service matchmaking</div>

        <div class="box-card">
          <div class="box-card-inner"
            :style="index===3?{marginRight:0}:{}"
            v-for="(item,index) in listArr" :key="index">
            <div class="title">
              <div class="img-box">
                <img :src="item.icon"/>
              </div>
              <div class="title-font" >{{item.title}}</div>
            </div>
            <div class="inline"></div>
            <div class="next-title">
              <div v-for="(items, indexs) in item.nextTitle"
              :key="indexs">
              {{items}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product',
  data () {
    return {
      listArr: [
        {
          icon: require('../assets/home4.png'),
          title: 'Zero cost of access',
          nextTitle: ['Charge by the account statement'],
          comtent: ''
        },
        {
          icon: require('../assets/home3.png'),
          title: 'Quick matchmaking',
          nextTitle: ['Quick deployment '],
          comtent: ''

        },
        {
          icon: require('../assets/home2.png'),
          title: 'Unified payment channel',
          nextTitle: ['Without matchmaking with other platforms'],
          comtent: ''
        },
        {
          icon: require('../assets/home1.png'),
          title: 'Professional qualification certification',
          nextTitle: ['Certificate of information security compliance'],
          comtent: ''
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.product
  padding-bottom 50px
  .index-image
      height:380px
      background-color: rgba(90, 90, 90, 1);
      background-image: url(../assets/bannerbghsy.jpeg);
      background-repeat: no-repeat;
      background-position: center
     .inner-text
      padding-top 100px
      margin 0 auto
      width 880px
      color #fff
      .title
        font-size 36px
        font-weight 500
      .content
        font-size 14px
        width 500px
        line-height 30px
  .index-next-content
     width 100%
    .inner-content
      width: 1100px
      margin 0 auto
      .main-title
        height:100px
        font-size 24px
        color #4e5969
        font-weight 600
        text-align center
        line-height 100px
      .next-main-title
        font-size 18px
        color #4e5969
        text-align center
        font-weight 600
        margin-bottom 20px
      .box-card
        color #86909c
        display flex
        text-align center
        .box-card-inner
          height 420px
          border-right 4px solid #fff
          width: 260px
          background-color #4A81C0
          display: inline-block
          padding 0 50px
          .title
            color:#fff
            font-size 24px
            font-weight 600px
            margin-bottom 10px
            .img-box
              height 100px
              padding-top 60px
            .title-font
              height 100px
              padding-bottom 20px
          .inline
            width 100px
            background #fff
            height 2px
            margin 0 auto
          .next-title
            color #fff
            padding-top 50px
            font-size 14px
</style>



// WEBPACK FOOTER //
// src/pages/home.vue